import { render, staticRenderFns } from "./ExternalApprovalsTab.vue?vue&type=template&id=7fca43c6&scoped=true"
import script from "./ExternalApprovalsTab.vue?vue&type=script&lang=js"
export * from "./ExternalApprovalsTab.vue?vue&type=script&lang=js"
import style0 from "./ExternalApprovalsTab.vue?vue&type=style&index=0&id=7fca43c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca43c6",
  null
  
)

export default component.exports